module.exports = __webpack_public_path__ + "img/art-34.efa514bf.png";